package com.parmartechnologies.core.feature.cart.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.feature.product.model.ProductPrice
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CartItem(
    @SerialName("unique_id") var uniqueID: Long = 0L,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
    @SerialName("customer_id") var customerId: String = "",
    @SerialName("product") var product: Product,
    @SerialName("inventory") var inventory: Inventory,
    @SerialName("price") var price: ProductPrice?,
    @SerialName("quantity") var quantity: Int = 1,
): BaseDataClass()